@import "@/styles/variables";

.wrapper {
	padding: 2rem;
	max-width: 900px;
	margin: 0 auto;
	font-family: "Inter", sans-serif;
	color: $gray-700;
}

.backButton {
	display: inline-flex;
	align-items: center;
	gap: 0.25rem;
	font-size: 0.875rem;
	color: $gray-500;
	background: none;
	border: none;
	cursor: pointer;
	margin-bottom: 1.5rem;
	padding: 0;
	transition: color 0.2s;

	&:hover {
		color: $gray-700;
	}
}

.card {
	background: #ffffff;
	border: 1px solid $gray-200;
	border-radius: $border-radius;
	overflow: hidden;
}

.cardHeader {
	display: flex;
	align-items: center;
	gap: 0.75rem;
	padding: 1.25rem 1.5rem;
	border-bottom: 1px solid $gray-200;

	.cardIcon {
		color: $primary-color;
	}

	h2 {
		font-size: 1.125rem;
		font-weight: 600;
		color: $gray-700;
		margin: 0;
	}
}

.toleranceRow {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1.25rem 1.5rem;
}

.toleranceInfo {
	display: flex;
	align-items: center;
	gap: 0.875rem;

	.toleranceIconWrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		background: $primary-light;
		border-radius: $border-radius-sm;
		color: $primary-color;
		flex-shrink: 0;
	}

	.toleranceText {
		h3 {
			font-size: 0.9375rem;
			font-weight: 500;
			color: $gray-700;
			margin: 0 0 0.2rem 0;
		}

		p {
			font-size: 0.8125rem;
			color: $gray-500;
			margin: 0;
		}
	}
}

.toggleWrapper {
	display: flex;
	align-items: center;
	gap: 0.625rem;
	flex-shrink: 0;
}

.toggleLabel {
	font-size: 0.875rem;
	font-weight: 500;
	color: $gray-500;

	&.active {
		color: $primary-color;
	}
}

.toggle {
	position: relative;
	display: inline-block;
	width: 44px;
	height: 24px;

	input {
		opacity: 0;
		width: 0;
		height: 0;
		position: absolute;
	}

	.track {
		position: absolute;
		inset: 0;
		background: $gray-300;
		border-radius: 9999px;
		cursor: pointer;
		transition: background 0.2s;

		&::after {
			content: "";
			position: absolute;
			top: 3px;
			left: 3px;
			width: 18px;
			height: 18px;
			background: #ffffff;
			border-radius: 50%;
			transition: transform 0.2s;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
		}
	}

	input:checked + .track {
		background: $primary-color;

		&::after {
			transform: translateX(20px);
		}
	}
}

.marginsSection {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1.5rem;
	padding: 0 1.5rem 1.5rem;
}

.marginField {
	display: flex;
	flex-direction: column;
	gap: 0.375rem;

	label {
		font-size: 0.875rem;
		font-weight: 500;
		color: $gray-600;
	}

	.inputWrapper {
		display: flex;
		align-items: center;
		background: #f3f3f3;
		border-radius: $border-radius-sm;
		overflow: hidden;

		input {
			flex: 1;
			border: none;
			background: transparent;
			padding: 0.625rem 0.75rem;
			font-size: 0.9375rem;
			color: $gray-700;
			outline: none;
			min-width: 0;

			&::-webkit-inner-spin-button,
			&::-webkit-outer-spin-button {
				-webkit-appearance: none;
			}
		}

		.inputSuffix {
			padding: 0.625rem 0.75rem 0.625rem 0;
			font-size: 0.9375rem;
			color: $gray-500;
			font-weight: 500;
			user-select: none;
		}
	}

	.helper {
		font-size: 0.75rem;
		color: $gray-400;
	}
}

.footer {
	margin-top: 2rem;
	display: flex;
	justify-content: flex-end;
}

.disabled {
	input {
		cursor: not-allowed;
		background: $gray-100;
	}
}
